import React, { useState } from 'react';
import { Collapse } from 'antd';
import Start from './views/Start';
import './App.scss';
import { formatNr, getMunicipalities, getSpendingCategories, roundNr } from './lib/utils';

const { Panel } = Collapse;

function App() {
	const showHeaders = true;
	const [ showResults, setShowResults ] = useState( false );
	const [ inputs, setInputs ] = useState( {} );
	const municipalities = getMunicipalities();
	const spendingCategories = getSpendingCategories();
	const [ stats, setStats ] = useState( {
		chosenMunicipality: null,
		vuositulot: null,
		ansiotulot: null,
		net_income: null,
		percent: null,
		total_tax: null,
		tax_lastyear: null,
		tulonhankkimisvahennys: 750,
		ylevero: null,
		tyoelakevakuutusmaksu: null,
		tyottomyysvakuutusmaksu: null,
		sairausvakuutuksen_paivarahamaksu: 0,
		valtioveron_alaiset_ansiotulot: null,
		ansiotulovahennys: null,
		perusvahennys: null,
		valtiovero: 0,
		enimmaistyotulovahennys: 0,
		tyotulovahennys: null,
		kuntavero: null,
		tax: null
	} );
	
	const createStats = () => {
		return new Promise( ( resolve, reject ) => {
			try {
				stats.chosenMunicipality = municipalities.filter( municipality => municipality.id === inputs.municipality )[ 0 ];
				stats.vuositulot = inputs.salary * 12.5;
				stats.ansiotulot = stats.vuositulot;
				stats.tulonhankkimisvahennys = ( stats.vuositulot > stats.tulonhankkimisvahennys ) ? stats.tulonhankkimisvahennys : stats.vuositulot;
				stats.ansiotulot = ( stats.vuositulot > stats.tulonhankkimisvahennys ) ? ( stats.ansiotulot - stats.tulonhankkimisvahennys ) : stats.ansiotulot - stats.tulonhankkimisvahennys;
				stats.ylevero = ( stats.ansiotulot < 14000 ) ? 0 : Math.min( ( stats.ansiotulot - 14000 ) * 0.025, 163 );
				stats.tyoelakevakuutusmaksu = stats.vuositulot * ( inputs.age ? 0.0865 : 0.0715 );
				stats.ansiotulot = stats.ansiotulot - stats.tyoelakevakuutusmaksu;
				stats.tyottomyysvakuutusmaksu = stats.vuositulot * 0.014;
				stats.ansiotulot = stats.ansiotulot - stats.tyottomyysvakuutusmaksu;
				if ( stats.vuositulot > 14766 ) {
					stats.sairausvakuutuksen_paivarahamaksu = stats.vuositulot * 0.0136;
					stats.ansiotulot = stats.ansiotulot - stats.sairausvakuutuksen_paivarahamaksu;
				}
				stats.valtioveron_alaiset_ansiotulot = stats.ansiotulot;
				stats.ansiotulovahennys = ( 7230 - 2500 ) * 0.51 + ( stats.vuositulot - 7230 ) * 0.28;
				stats.ansiotulovahennys = stats.ansiotulovahennys > 3570 ? 3570 : stats.ansiotulovahennys;
				stats.ansiotulovahennys = stats.ansiotulovahennys - ( stats.vuositulot - stats.tulonhankkimisvahennys - 14000 ) * 0.045;
				stats.ansiotulovahennys = stats.ansiotulovahennys < 0 ? 0 : stats.ansiotulovahennys;
				stats.perusvahennys = 3630 - ( stats.ansiotulot - stats.ansiotulovahennys - 3630 ) * 0.18;
				stats.perusvahennys = stats.perusvahennys < 0 ? 0 : stats.perusvahennys;
				
				if ( stats.valtioveron_alaiset_ansiotulot > 80500 ) {
					stats.valtiovero = ( stats.valtioveron_alaiset_ansiotulot - 80500 ) * 0.3125 + 11023.5;
				} else if ( stats.valtioveron_alaiset_ansiotulot > 45900 ) {
					stats.valtiovero = ( stats.valtioveron_alaiset_ansiotulot - 45900 ) * 0.2125 + 3671;
				} else if ( stats.valtioveron_alaiset_ansiotulot > 27900 ) {
					stats.valtiovero = ( stats.valtioveron_alaiset_ansiotulot - 27900 ) * 0.1725 + 566;
				} else if ( stats.valtioveron_alaiset_ansiotulot > 18600 ) {
					stats.valtiovero = ( stats.valtioveron_alaiset_ansiotulot - 18600 ) * 0.06 + 8;
				}
				
				if ( stats.vuositulot - stats.tulonhankkimisvahennys > 33000 ) {
					let valtioveron_alaiset_ansiotulot_max = ( stats.valtioveron_alaiset_ansiotulot - 2500 ) * 0.127;
					valtioveron_alaiset_ansiotulot_max = valtioveron_alaiset_ansiotulot_max > 1840 ? 1840 : valtioveron_alaiset_ansiotulot_max;
					stats.enimmaistyotulovahennys = Math.max( valtioveron_alaiset_ansiotulot_max - ( stats.vuositulot - stats.tulonhankkimisvahennys - 33000 ) * 0.0189,
						0 );
				} else {
					stats.enimmaistyotulovahennys = 1840;
				}
				
				stats.tyotulovahennys = Math.max( stats.enimmaistyotulovahennys - stats.valtiovero, 0 );
				stats.valtiovero = Math.max( stats.valtiovero - stats.enimmaistyotulovahennys - stats.tyotulovahennys, 0 );
				stats.ansiotulot = stats.ansiotulot - stats.ansiotulovahennys - stats.perusvahennys;
				
				stats.kuntavero = Math.max( stats.ansiotulot * ( stats.chosenMunicipality.tax_percent / 100 ) - stats.tyotulovahennys, 0 );
				
				stats.tax = stats.tyoelakevakuutusmaksu + stats.tyottomyysvakuutusmaksu + stats.sairausvakuutuksen_paivarahamaksu + stats.kuntavero + stats.valtiovero + stats.ylevero;
				
				stats.net_income = stats.vuositulot - stats.tax;
				stats.percent = inputs.age ? 0.187 : 0.2020;
				stats.total_tax = stats.tax + stats.net_income * 0.2 + inputs.salary * 12.5 * stats.percent;
				
				resolve( stats );
			} catch ( error ) {
				reject( error.toString() );
			}
		} );
	};
	
	const handleSetShowResults = async ( value ) => {
		const stats = await createStats();
		await setStats( stats );
		/*await printResults();*/
		setShowResults( value );
	};
	
	const checkInputsValidity = () => {
		return inputs.municipality && inputs.salary;
	};
	
	return (
		<article>
			{ showHeaders &&
			<div className="headers">
				<p>Laskuri huomioi <a href="http://stat.fi/til/vermak/index.html" target="_blank" rel="noreferrer">verot sekä pakolliset
					veronluonteiset maksut.</a></p>
			</div>
			}
			{ !showResults &&
			<div className="start">
				<Start
					municipalities={ municipalities }
					onSetShowResults={ handleSetShowResults }
					onSetMunicipality={ ( value ) => setInputs( { ...inputs, municipality: value } ) }
					onSetSalary={ ( value ) => setInputs( { ...inputs, salary: value } ) }
					onSetAge={ ( value ) => setInputs( { ...inputs, age: value } ) }
					valid={ checkInputsValidity() }
				/>
			</div>
			}
			{ showResults && stats && stats.tax <= 0 &&
			<div className="verotin">
				<div className="result_container">
					<div className="spendings_container">
						<div className="padding-horizontal">
							<h3>Et maksa veroja</h3>
							<p>Tulosi ovat niin alhaiset, että et maksa lainkaan veroja.</p>
						</div>
					</div>
				</div>
			</div>
			}
			{ showResults && stats && stats.tax > 0 &&
			<div className="verotin">
				<div className="result_container">
					<div className="result_wrapper start">
						<div className="label">Vuositulosi</div>
						<div className="value">{ formatNr( roundNr( stats.vuositulot ), 0 ) } €</div>
					</div>
					<div className="result_wrapper">
						<div className="label">Verot ja maksut bruttopalkasta</div>
						<div className="value">{ formatNr(
							roundNr( stats.tax, 0 ) ) } €
						</div>
					</div>
					<div className="result_wrapper">
						<div className="label">Arvonlisä- ja valmistevero nettopalkasta</div>
						<div className="value">{ formatNr(
							roundNr( stats.net_income * 0.2, 0 ) ) } €
						</div>
					</div>
					<div className="result_wrapper">
						<div className="label">Työnantajasi maksaa</div>
						<div className="value">{ formatNr(
							roundNr( inputs.salary * 12.5 * stats.percent ) ) } €
						</div>
					</div>
					<div className="result_wrapper total">
						<div className="label">Maksut yhteensä</div>
						<div className="value">{ formatNr(
							roundNr( stats.total_tax, 0 ) ) } €
						</div>
					</div>
					<div className="spendings_container">
						<div className="padding-horizontal">
							<h3>Veroeurosi jakaantuvat seuraavasti</h3>
							<p>Valitsemalla kategorian näet tarkemmat tiedot</p>
						</div>
						<Collapse
							bordered={ false }
							className="category_container main"
						>
							{ spendingCategories.map( ( spending_category, index ) => {
									const panelHeader = <div className="spending_category_header">
										<div className="category_name">{ spending_category.title }</div>
										<div
											className="category_share">{ formatNr( roundNr( spending_category.share * stats.total_tax, 0 ) ) } €
										</div>
									</div>;
									
									return (
										<Panel className="spending_category_container" header={ panelHeader } key={ index }>
											{ spending_category.subcategories.map( ( subCategory, subIndex ) =>
												<div className="category_container sub" key={ subIndex }>
													<div className="category_name">{ subCategory.title }</div>
													<div className="category_share">{ formatNr(
														roundNr( subCategory.share * stats.total_tax, 0 ) ) } €
													</div>
												</div>
											) }
										</Panel>
									);
								}
							) }
						</Collapse>
					</div>
				</div>
			</div>
			}
			{ showHeaders &&
			<>
				<div className="footer"></div>
			</>
			}
		</article>
	);
	
}

export default App;
